

import { Box, Card, Typography } from '@mui/material';
import {
  MRT_RowData,
  MaterialReactTable,
  useMaterialReactTable, //import alternative sub-component if we do not want toolbars
  type MRT_ColumnDef,
  type MRT_TableOptions,
  MRT_ColumnFiltersState
} from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';


interface SampleTableProps<T extends MRT_RowData> extends MRT_TableOptions<T> {
  columns: MRT_ColumnDef<T>[];
  data: T[];
  rowNumber?: boolean;
  enablePagination?: boolean;
  density?: 'comfortable' | 'compact' | 'spacious';
  // enableTopToolbar?: boolean;
  isLoading?: boolean;
  setColumnFilters?: React.Dispatch<React.SetStateAction<MRT_ColumnFiltersState>>
  columnFilters?: MRT_ColumnFiltersState
  labelRenderTopToolbarCustomActions?: string
  backgroundColor?: string
}

//** Componente tabla renderizar informacion y paginacion automatica */
const SampleTableFullData = <T extends MRT_RowData>({
  columns,
  data,
  density = 'comfortable',
  rowNumber = false,
  isLoading = false,
  setColumnFilters,
  columnFilters,
  labelRenderTopToolbarCustomActions = 'Total de registros:',
  backgroundColor = '#A0C878'
}: SampleTableProps<T>) => {

  const table = useMaterialReactTable({
    columns,
    data,
    localization: MRT_Localization_ES,
    enableRowNumbers: rowNumber,
    enableRowVirtualization: rowNumber,
    enableColumnFilters: true,
    enableSorting: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: true,
    enableColumnActions: true,
    enableRowActions: false,
    enableTopToolbar: true,
    state: {
      expanded: true,
      density: density,
      isLoading: isLoading,
      ...(columnFilters && { columnFilters }),
    },
    autoResetPageIndex: false,
    initialState: {
      pagination: { pageSize: 5, pageIndex: 0 },
    },
    ///* filtros
    ...(setColumnFilters && setColumnFilters),

    ///* estilos
    muiTablePaperProps: {
      elevation: 0,
    },
    muiTableBodyCellProps: {
      align: 'center',
    },
    defaultColumn: {
      muiTableBodyCellProps: ({ row }) => ({
        sx: {
          backgroundColor: row.original.check
            ? backgroundColor
            : undefined,
        },
      }),
    },
    muiTableHeadCellProps: {
      align: 'center',
    },
    renderTopToolbarCustomActions: (row) => (
      <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
        {`${labelRenderTopToolbarCustomActions}: ${row.table.getRowCount()}`}
      </Typography>
    ),
  });

  return (
    <Card>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <MaterialReactTable table={table} />
      </Box>
    </Card>
  );
};

export default SampleTableFullData;